export default "<div class=\"badge\">\r\n  <ion-icon [name]='icon'></ion-icon>{{text}}\r\n</div>\r\n";